import { render, staticRenderFns } from "./pcbaPage.vue?vue&type=template&id=00cb54d0&scoped=true&"
import script from "./pcbaPage.vue?vue&type=script&lang=js&"
export * from "./pcbaPage.vue?vue&type=script&lang=js&"
import style0 from "./pcbaPage.vue?vue&type=style&index=0&id=00cb54d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb54d0",
  null
  
)

export default component.exports